import { CURRENCYLIST_SEARCH, CURRENCYLIST_PAGE } from '../actions/currencylistactions';

const state = { search:'', page:0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [CURRENCYLIST_SEARCH]: ({ commit }, search) => {
        commit(CURRENCYLIST_SEARCH, search);
    },
    [CURRENCYLIST_PAGE]: ({ commit }, page) => {
        commit(CURRENCYLIST_PAGE, page);
    }
};

const mutations = {
    [CURRENCYLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [CURRENCYLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};